import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../chat-menu-dialog.action';
import { ChatMenuDialogState } from '../chat-menu-dialog.state';

import { Navigate } from './navigate.action';

export function navigateReducer(
    state: ChatMenuDialogState,
    action: PayloadAction<ActionType.TC__CM__NAVIGATE, Navigate>,
): ChatMenuDialogState {
    try {
        return {
            ...state,
            nav: action.payload.nav ?? state.nav,
            /* TODO revise retaining nav location and context when dialog is closed/reopened */
            ctx: action.payload.ctx ?? state.ctx,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
